import './style.scss';

import React, { useCallback } from 'react';

import PairWalletsContextProvider from 'context/PairWalletsContext/PairWalletsContext';
import { DexWalletsTable } from 'tables/dex';
import { IDexPair } from 'types/pairs';

interface IArbitrageDexWalletsTableProps {
  pair: IDexPair;
  selectedWalletId?: number;
  onSelectWalletId: (walletId?: number) => void;
}

const ArbitrageDexWalletsTable: React.FC<IArbitrageDexWalletsTableProps> = ({
  pair,
  onSelectWalletId,
  selectedWalletId,
}) => {
  const handleSelectWallet = useCallback(
    (walletIds: number[]) => {
      const selected = walletIds[0];

      if (selected !== 0 && !isNaN(selected)) {
        onSelectWalletId(selected);
      } else {
        onSelectWalletId(undefined);
      }
    },
    [onSelectWalletId],
  );

  return (
    <div className="arbitrage-dex-wallets-table">
      <div className="arbitrage-dex-wallets-table-title">Wallets</div>
      <PairWalletsContextProvider
        dexPair={pair}
        initialSelected={selectedWalletId !== undefined ? { [selectedWalletId]: true } : {}}
        onChangeSelected={handleSelectWallet}
      >
        <DexWalletsTable
          singleSelect={true}
          dexPair={pair}
          showActions={false}
          showTxCount={false}
          showTotalUsd={false}
        />
      </PairWalletsContextProvider>
    </div>
  );
};

export { ArbitrageDexWalletsTable };
